<header class="fixed top-0 z-50 w-full shadow-lg" style="background: linear-gradient(135deg, #0ea5e9 0%, #4f46e5 100%)">
  <div class="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">

    <!-- Logo -->
    <div class="flex items-center gap-8">
      <app-brand-logo
        [light]="true"
        [markSize]="44"
        [wordmarkSize]="24"
        hostClass="items-center gap-3" />

      <!-- Desktop Nav -->
      <nav class="hidden items-center gap-6 md:flex">
        <a routerLink="/search"
          class="text-sm font-medium no-underline transition-colors hover:text-white"
          style="color: rgba(255,255,255,0.8)">
          Find Providers
        </a>
        <a href="#how-it-works"
          class="text-sm font-medium no-underline transition-colors hover:text-white"
          style="color: rgba(255,255,255,0.8)">
          How It Works
        </a>
        <a href="#"
          class="text-sm font-medium no-underline transition-colors hover:text-white"
          style="color: rgba(255,255,255,0.8)">
          Become a Provider
        </a>
      </nav>
    </div>

    <!-- Auth Actions (Desktop) -->
    <div class="hidden items-center gap-3 md:flex">
      @if (isAuthenticated) {
        <!-- Bell notification -->
        <div class="notif-panel-wrapper relative">
          <button
            (click)="toggleNotifPanel()"
            class="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border transition-colors"
            style="border-color: rgba(255,255,255,0.4); color: white; background: rgba(255,255,255,0.12)"
          >
            <i class="pi pi-bell text-sm"></i>
            @if (notificationService.unreadCount() > 0) {
              <span
                class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold text-white"
                style="background: var(--destructive)"
              >
                {{ notificationService.unreadCount() > 9 ? '9+' : notificationService.unreadCount() }}
              </span>
            }
          </button>

          @if (notifPanelOpen) {
            <div
              class="absolute right-0 top-full z-50 mt-2 w-80 rounded-xl border bg-white shadow-lg"
              style="border-color: var(--border)"
            >
              <div class="flex items-center justify-between border-b px-4 py-3" style="border-color: var(--border)">
                <p class="text-sm font-semibold" style="color: var(--foreground)">Notifications</p>
                @if (notificationService.notifications().length > 0) {
                  <button
                    (click)="notificationService.clearAll()"
                    class="cursor-pointer border-none bg-transparent p-0 text-xs transition-colors hover:underline"
                    style="color: var(--muted-foreground)"
                  >
                    Clear all
                  </button>
                }
              </div>
              @if (notificationService.notifications().length === 0) {
                <div class="flex flex-col items-center gap-2 px-4 py-8">
                  <i class="pi pi-bell text-2xl" style="color: var(--muted-foreground)"></i>
                  <p class="text-sm" style="color: var(--muted-foreground)">No notifications yet</p>
                </div>
              } @else {
                <ul class="max-h-72 divide-y overflow-y-auto" style="border-color: var(--border)">
                  @for (notif of notificationService.notifications(); track notif.id) {
                    <li class="px-4 py-3">
                      <div class="flex items-start gap-3">
                        <i
                          [class]="notifIcon(notif.type) + ' mt-0.5 shrink-0 text-sm'"
                          [style]="'color: ' + notifColor(notif.type)"
                        ></i>
                        <div class="min-w-0 flex-1">
                          @if (notif.title) {
                            <p class="text-sm font-semibold" style="color: var(--foreground)">{{ notif.title }}</p>
                          }
                          <p class="text-sm leading-snug" style="color: var(--muted-foreground)">{{ notifPreview(notif.message, notif.title) }}</p>
                          @if (isNotifTruncated(notif.message, notif.title)) {
                            <button
                              type="button"
                              (click)="openNotificationsPage(notif.id)"
                              class="mt-1 cursor-pointer border-none bg-transparent p-0 text-xs font-semibold"
                              style="color: var(--primary-600)"
                            >
                              Read more
                            </button>
                          }
                          <p class="mt-1 text-xs" style="color: var(--muted-foreground)">
                            {{ notif.timestamp | date: 'h:mm a' }}
                          </p>
                        </div>
                      </div>
                    </li>
                  }
                </ul>
                <div class="border-t px-4 py-2.5 text-center" style="border-color: var(--border)">
                  <button
                    type="button"
                    (click)="openNotificationsPage()"
                    class="cursor-pointer border-none bg-transparent p-0 text-xs font-semibold"
                    style="color: var(--primary-600)"
                  >
                    View all notifications
                  </button>
                </div>
              }
            </div>
          }
        </div>

        <div class="user-dropdown-wrapper relative">
          <button
            (click)="toggleDropdown()"
            class="flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors"
            style="border-color: rgba(255,255,255,0.4); color: white; background: rgba(255,255,255,0.12)">
            <span
              class="flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold text-white"
              style="background: rgba(255,255,255,0.25)">
              {{ Initials }}
            </span>
            <span>{{ FirstName }}</span>
            <i class="pi pi-angle-down text-xs" style="color: rgba(255,255,255,0.6)"></i>
          </button>

          @if (dropdownOpen) {
            <div
              class="absolute right-0 top-full z-50 mt-2 w-52 rounded-xl border bg-white py-1 shadow-lg"
              style="border-color: var(--border)">
              <div class="border-b px-4 py-3" style="border-color: var(--border)">
                <p class="text-sm font-semibold" style="color: var(--foreground)">
                  {{ FullName }}
                </p>
                <p class="text-xs capitalize" style="color: var(--muted-foreground)">
                  {{ UserRole }}
                </p>
              </div>
              <a [routerLink]="profileRoute" (click)="dropdownOpen = false"
                class="flex items-center gap-3 px-4 py-2.5 text-sm no-underline transition-colors hover:bg-gray-50"
                style="color: var(--foreground)">
                <i class="pi pi-user text-sm" style="color: var(--muted-foreground)"></i> My Profile
              </a>
              <a [routerLink]="dashboardRoute" (click)="dropdownOpen = false"
                class="flex items-center gap-3 px-4 py-2.5 text-sm no-underline transition-colors hover:bg-gray-50"
                style="color: var(--foreground)">
                <i class="pi pi-home text-sm" style="color: var(--muted-foreground)"></i> Dashboard
              </a>
              <a [routerLink]="profileRoute" [queryParams]="{tab: 'security'}" (click)="dropdownOpen = false"
                class="flex items-center gap-3 px-4 py-2.5 text-sm no-underline transition-colors hover:bg-gray-50"
                style="color: var(--foreground)">
                <i class="pi pi-lock text-sm" style="color: var(--muted-foreground)"></i> Change Password
              </a>
              <div class="border-t" style="border-color: var(--border)"></div>
              <button (click)="logout()"
                class="flex w-full cursor-pointer items-center gap-3 border-none bg-transparent px-4 py-2.5 text-sm transition-colors hover:bg-red-50"
                style="color: var(--destructive)">
                <i class="pi pi-sign-out text-sm"></i> Log Out
              </button>
            </div>
          }
        </div>
      } @else {
        <a
          routerLink="/auth/login"
          class="header-auth-btn header-auth-btn--login inline-flex items-center justify-center rounded-full border px-4 py-2 text-sm font-medium no-underline transition-colors"
        >
          Log In
        </a>
        <a
          routerLink="/auth/register"
          class="header-auth-btn header-auth-btn--signup inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium no-underline transition-colors"
        >
          Sign Up
        </a>
      }
    </div>

    <!-- Mobile Bell + Menu Button -->
    <div class="flex items-center gap-2 md:hidden">
      @if (isAuthenticated) {
        <div class="notif-panel-wrapper relative">
          <button
            (click)="toggleNotifPanel()"
            class="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border"
            style="border-color: rgba(255,255,255,0.4); color: white; background: rgba(255,255,255,0.12)"
          >
            <i class="pi pi-bell text-sm"></i>
            @if (notificationService.unreadCount() > 0) {
              <span
                class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold text-white"
                style="background: var(--destructive)"
              >
                {{ notificationService.unreadCount() > 9 ? '9+' : notificationService.unreadCount() }}
              </span>
            }
          </button>
          @if (notifPanelOpen) {
            <div
              class="absolute right-0 top-full z-50 mt-2 w-72 rounded-xl border bg-white shadow-lg"
              style="border-color: var(--border)"
            >
              <div class="flex items-center justify-between border-b px-4 py-3" style="border-color: var(--border)">
                <p class="text-sm font-semibold" style="color: var(--foreground)">Notifications</p>
                @if (notificationService.notifications().length > 0) {
                  <button
                    (click)="notificationService.clearAll()"
                    class="cursor-pointer border-none bg-transparent p-0 text-xs"
                    style="color: var(--muted-foreground)"
                  >Clear all</button>
                }
              </div>
              @if (notificationService.notifications().length === 0) {
                <div class="flex flex-col items-center gap-2 px-4 py-6">
                  <i class="pi pi-bell text-xl" style="color: var(--muted-foreground)"></i>
                  <p class="text-sm" style="color: var(--muted-foreground)">No notifications yet</p>
                </div>
              } @else {
                <ul class="max-h-64 divide-y overflow-y-auto" style="border-color: var(--border)">
                  @for (notif of notificationService.notifications(); track notif.id) {
                    <li class="px-4 py-3">
                      <div class="flex items-start gap-3">
                        <i
                          [class]="notifIcon(notif.type) + ' mt-0.5 shrink-0 text-sm'"
                          [style]="'color: ' + notifColor(notif.type)"
                        ></i>
                        <div class="min-w-0 flex-1">
                          @if (notif.title) {
                            <p class="text-sm font-semibold" style="color: var(--foreground)">{{ notif.title }}</p>
                          }
                          <p class="text-sm leading-snug" style="color: var(--muted-foreground)">{{ notifPreview(notif.message, notif.title) }}</p>
                          @if (isNotifTruncated(notif.message, notif.title)) {
                            <button
                              type="button"
                              (click)="openNotificationsPage(notif.id)"
                              class="mt-1 cursor-pointer border-none bg-transparent p-0 text-xs font-semibold"
                              style="color: var(--primary-600)"
                            >
                              Read more
                            </button>
                          }
                          <p class="mt-1 text-xs" style="color: var(--muted-foreground)">
                            {{ notif.timestamp | date: 'h:mm a' }}
                          </p>
                        </div>
                      </div>
                    </li>
                  }
                </ul>
                <div class="border-t px-4 py-2.5 text-center" style="border-color: var(--border)">
                  <button
                    type="button"
                    (click)="openNotificationsPage()"
                    class="cursor-pointer border-none bg-transparent p-0 text-xs font-semibold"
                    style="color: var(--primary-600)"
                  >
                    View all notifications
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
      <button
        class="flex items-center justify-center h-9 w-9 rounded-md border"
        style="border-color: rgba(255,255,255,0.4); color: white; background: rgba(255,255,255,0.12)"
        (click)="toggleMobileMenu()">
        <i [class]="mobileMenuOpen ? 'pi pi-times' : 'pi pi-bars'"></i>
      </button>
    </div>
  </div>

  <!-- Mobile Menu -->
  @if (mobileMenuOpen) {
    <div class="border-t bg-white px-4 py-4 md:hidden" style="border-color: var(--border)">
      <nav class="flex flex-col gap-4">
        <a routerLink="/search" (click)="toggleMobileMenu()"
          class="text-sm font-medium no-underline" style="color: var(--muted-foreground)">
          Find Providers
        </a>
        <a href="#how-it-works" (click)="toggleMobileMenu()"
          class="text-sm font-medium no-underline" style="color: var(--muted-foreground)">
          How It Works
        </a>
        <a href="#" (click)="toggleMobileMenu()"
          class="text-sm font-medium no-underline" style="color: var(--muted-foreground)">
          Become a Provider
        </a>
        <div class="flex flex-col gap-2 border-t pt-2" style="border-color: var(--border)">
          @if (isAuthenticated) {
            <div class="mb-2 flex items-center gap-3 rounded-xl border px-3 py-2.5" style="border-color: var(--border)">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white"
                [style]="'background: ' + 'var(--accent-500)'">
                {{ Initials }}
              </span>
              <div>
                <p class="text-sm font-semibold" style="color: var(--foreground)">{{ FullName }}</p>
                <p class="text-xs capitalize" style="color: var(--muted-foreground)">{{ UserRole }}</p>
              </div>
            </div>
            <a [routerLink]="profileRoute" (click)="toggleMobileMenu()"
              class="flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm no-underline"
              style="border-color: var(--border); color: var(--foreground)">
              <i class="pi pi-user text-sm"></i> My Profile
            </a>
            <a [routerLink]="dashboardRoute" (click)="toggleMobileMenu()"
              class="flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm no-underline"
              style="border-color: var(--border); color: var(--foreground)">
              <i class="pi pi-home text-sm"></i> Dashboard
            </a>
            <button (click)="logout()"
              class="flex w-full cursor-pointer items-center gap-2 rounded-lg border-none px-4 py-2.5 text-sm"
              style="background: rgba(220,38,38,0.08); color: var(--destructive)">
              <i class="pi pi-sign-out text-sm"></i> Log Out
            </button>
          } @else {
            <a
              routerLink="/auth/login"
              (click)="toggleMobileMenu()"
              class="header-auth-btn header-auth-btn--mobile-login flex w-full items-center justify-center rounded-lg border px-4 py-2.5 text-sm font-medium no-underline transition-colors"
            >
              Log In
            </a>
            <a
              routerLink="/auth/register"
              (click)="toggleMobileMenu()"
              class="header-auth-btn header-auth-btn--mobile-signup flex w-full items-center justify-center rounded-lg px-4 py-2.5 text-sm font-medium no-underline transition-colors"
            >
              Sign Up
            </a>
          }
        </div>
      </nav>
    </div>
  }
</header>
